import { TeamMember } from "../team-member";
import { TeamMemberCreationItention, TeamRepository } from "./TeamRepository";

export class TeamRepositoryInMemory implements TeamRepository {
  constructor(private teamMembers: TeamMember[] = []) {
    // this.teamMembers.push({ name: "Ana", id: "1" });
    // this.teamMembers.push({ name: "John", id: "2" });
    // this.teamMembers.push({ name: "Charles", id: "3" });
    // this.teamMembers.push({ name: "Marta", id: "4" });
  }

  removeMember(member: TeamMember): Promise<void> {
    return Promise.resolve()
  }

  addMember(teamMemberInformation: TeamMemberCreationItention): Promise<TeamMember> {
    const { name } = teamMemberInformation;
    return Promise.resolve({ name, id: Math.random().toString() });
  };

  findAllTeamMembers(): Promise<TeamMember[]> {
    return Promise.resolve(this.teamMembers);
  }
}